module.exports = __webpack_public_path__ + "static/bss-commerce-a6a6975c29b81c12f55e671536b1a3d4.svg";